// extracted by mini-css-extract-plugin
module.exports = {"colophon":"footer-module--colophon--17Qs1","fadein":"footer-module--fadein--3pn5N","customMedia":{},"customProperties":{},"customSelectors":{}};